<template>
    <v-menu transition="slide-y-transition" open-on-hover :close-on-content-click="false" :close-delay="200" bottom offset-y content-class="myprovet-menu-card top-distance">
        <template v-slot:activator="{ on, attrs }">
            <slot v-bind:event="{ on, attrs }" />
        </template>

        <v-card class="myprovet-menu-card-inner">
            <v-card-title v-if="title" class="d-flex justify-space-between align-center mx-1">
                <span class="title-text dark-blue-color" v-text="title"></span>
                <a href="#" v-if="hasUnreadItems" @click="markAllAsRead" class="font-size-md text-decoration-none light-blue-color" v-text="subtitle"></a>
            </v-card-title>

            <v-card-text v-if="!hasItems" class="fill-height d-flex align-center justify-center" :style="notificationsMenu ? 'width: 466px' : ''">
                <span>{{ $t('navbar.noNotifications') }}</span>
            </v-card-text>

            <v-card-text v-else class="px-0" v-bind:class="{ 'myprovet-menu-card-scroll': isScrollable }">
                <v-list flat data-cy="navbar-user-menu">
                    <v-list-item-group>
                        <v-list-item v-if="showUserMenu" @click="openUserDetailsDialog" :disabled="!userStore.hasPermissionTo('View user details dialog')">
                            <v-list-item-icon>
                                <v-icon class="appbar-icon-button btn-bg-color-blue dark-blue-color">mdi-account-cog</v-icon>
                            </v-list-item-icon>

                            <v-list-item-content :style="notificationsMenu ? 'width: 466px' : ''">
                                <v-list-item-title class="font-size-md dark-blue-color">{{ $t('navbar.myAccount') }}</v-list-item-title>
                                <v-list-item-subtitle v-if="getUserEmail" class="font-size-sm">{{ getUserEmail }}</v-list-item-subtitle>
                            </v-list-item-content>
                        </v-list-item>

                        <v-divider v-if="items && items.length" class="mx-4" style="border-color: rgba(196, 196, 196, 0.2)"></v-divider>

                        <template v-for="(item, index) in getItems">
                            <!-- :style="!item.read ? 'background: #F4F7FA !important;' : ''" -->
                            <v-list-item :data-cy="item.dataCy ? item.dataCy : null" :style="notificationsMenu ? 'cursor: default !important' : ''" :class="{ 'notification-unread': notificationsMenu && !item.read, 'notification-line': notificationsMenu }" :key="index" @click="itemClick(item)">
                                <v-list-item-icon>
                                    <v-icon
                                        :class="{
                                            'btn-bg-color-dark-blue white-color': notificationsMenu && !item.read,
                                            'btn-bg-color-blue dark-blue-color': notificationsMenu && item.read,
                                            'appbar-icon-button btn-bg-color-blue dark-blue-color': !notificationsMenu,
                                        }"
                                        class="appbar-icon-button"
                                        v-text="item.icon"
                                    ></v-icon>
                                </v-list-item-icon>

                                <v-list-item-content :style="notificationsMenu ? 'width: 466px' : ''">
                                    <v-list-item-title :class="{ 'font-weight-bold': notificationsMenu && !item.read }" class="font-size-md dark-blue-color" v-text="item.titleKey ? $t(item.titleKey) : tnTitle(item.title)"></v-list-item-title>
                                    <v-list-item-subtitle v-if="item.subtitle" class="font-size-sm" v-text="tnSubtitle(item.subtitle)"></v-list-item-subtitle>
                                </v-list-item-content>

                                <inertia-link v-if="item.route && rightIcon" :href="item.route" class="no-underline">
                                    <v-list-item-icon :style="notificationsMenu ? 'cursor: pointer !important' : ''">
                                        <v-tooltip bottom open-on-hover content-class="myprovet-tooltip">
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-icon
                                                    v-bind="attrs"
                                                    v-on="on"
                                                    :class="{
                                                        'btn-bg-color-dark-blue white-color': notificationsMenu && !item.read,
                                                        'btn-bg-color-blue dark-blue-color': notificationsMenu && item.read,
                                                    }"
                                                    class="appbar-icon-button btn-bg-color-blue dark-blue-color"
                                                    v-text="rightIcon"
                                                ></v-icon>
                                            </template>

                                            <span>{{ $t('navbar.openAssociatedPage') }}</span>
                                        </v-tooltip>
                                    </v-list-item-icon>
                                </inertia-link>

                                <v-list-item-icon v-else></v-list-item-icon>
                            </v-list-item>

                            <v-divider v-if="index < items.length - 1" :key="`${index}-divider`" class="mx-4" style="border-color: rgba(196, 196, 196, 0.2)"></v-divider>
                        </template>
                    </v-list-item-group>
                </v-list>
            </v-card-text>
        </v-card>
    </v-menu>
</template>

<script>
import { mapStores } from 'pinia';
import { useUserStore } from '@/Stores/user';

export default {
    props: {
        items: { title: '', subtitle: '', icon: '', url: '' },
        title: {
            type: String,
            default: '',
        },
        subtitle: {
            type: String,
            default: '',
        },
        rightIcon: {
            type: String,
            default: '',
        },
        notificationsMenu: {
            type: Boolean,
            default: false,
        },
        isScrollable: {
            type: Boolean,
            default: false,
        },
        showUserMenu: {
            type: Boolean,
            default: false,
        },
    },

    data: () => ({
        pagesWithTutorial: ['/dashboard'],
        notificationReadIcon: 'mdi-check',
    }),

    computed: {
        ...mapStores(useUserStore),

        getUserEmail() {
            return this.userStore.user?.email;
        },

        getItems() {
            return this.items.filter((item) => this.hasPermission(item) && this.userHasSeller(item) && (!item.isTutorialButton || this.pagesWithTutorial.includes(this.$page.url)));
        },

        hasItems() {
            return this.items?.length > 0;
        },

        hasUnreadItems() {
            return this.items?.filter((item) => item.read === false).length > 0;
        },
    },

    methods: {
        itemClick(item) {
            if (this.notificationsMenu) {
                if (item.text) {
                    this.$emit('open-notification', item);
                }
                return this.markAsRead(item);
            }

            if (item.action) item.action();
        },

        hasPermission(item) {
            if (!('permission' in item)) {
                return true;
            }

            return this.userStore.hasPermissionTo(item.permission);
        },

        markAllAsRead() {
            this.$emit('mark-all-as-read');
        },

        markAsRead(notification) {
            this.$emit('mark-as-read', notification);
        },

        userHasSeller(item) {
            return !(item.titleKey === 'layout.menu.createUserRequest' && this.userStore.user?.seller_id == null);
        },

        openUserDetailsDialog() {
            window.EventBus.$emit('open-user-details-dialog');
        },
    },
};
</script>

<style>
.notification-unread {
    background: #f4f7fa;
    box-shadow: inset 3px 0px 0px 0px #0d8ccd, inset 0px -20px 20px 0px rgb(214 222 230 / 18%);
}
</style>
